import toast from 'react-hot-toast'
import { Loader2 } from 'lucide-react'

export const showLoadingToast = (message: string, id: string) => {
  return toast.loading(message, {
    id,
    style: {
      borderRadius: '12px',
      background: 'hsl(var(--background))',
      color: 'hsl(var(--foreground))',
      border: '1px solid hsl(var(--border))',
      boxShadow:
        '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
      padding: '12px 20px',
      fontSize: '14px',
      fontWeight: '600',
      minWidth: '200px',
    },
    icon: <Loader2 className='h-5 w-5 animate-spin text-primary' />,
  })
}

export const dismissLoadingToast = (id: string) => {
  toast.dismiss(id)
}
